import clsx from 'clsx';
import type { CSSProperties, FC, PropsWithChildren } from 'react';

import styles from './Overlapping.module.scss';

type OverlappingProps = {
  className?: string;
  style?: CSSProperties;
};
const Overlapping: FC<PropsWithChildren<OverlappingProps>> = ({ children, className, style }) => (
  <div className={clsx(styles['overlapping'], className)} style={style}>
    {children}
  </div>
);

export default Overlapping;
